import Vue from "vue"
import VueI18n from "vue-i18n";
import sc from "./locale/sc"
import en from "./locale/en"
import tc from "./locale/tc"

Vue.use(VueI18n); // 全局挂载
export const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
  messages: {
    tc,
    sc, //
    en,
  }
});

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js